import FormLabel from "../../../component/input/FormLabel.component";
import { useFormik } from "formik";
import { useParams } from "react-router";
import GridComponent from "../../../component/grid/GridComponent.component";
import { FormInput, FormControlRadio, FormRadio, FormSelect } from "../../../component/input/InputStyle";
import { FormInterface } from "../../../core/interfaces/form/Form";
import ParamTypes from "../../../core/interfaces/ParamTypes";
import MenuItem from "@material-ui/core/MenuItem";
import ButtonForm from "../../../component/buttton/ButtonForm.component";
import Details from "../operationalIndicator/Details.component";
import { RatingScore, RatingScoreInterface } from "../utils/RatingScore";
import { QuestionRequired, QuestionRequiredInterface } from "../utils/QuestionRequired";
import {ResearchQuestionInterface } from "../interfaces/ResearchQuestion";
import Progresse from "../../../component/progress/Progress.component";
import { useEffect } from "react";
import { getByIdResearchQuestion } from "../../rating/Assesment.service";

export default function FormComponent({ handleSubmitForm, initialValues, disabled, request, id} : FormInterface<ResearchQuestionInterface>) {

    useEffect(() => {
        if (id) {
            getByIdResearchQuestion(id).then(res => {
                setFieldValue('dsPesquisa', res.data.dsPesquisa);
                setFieldValue('valoresPesquisa', res.data.flNPS ? String(RatingScore[1].key) : String(RatingScore[0].key))
                setFieldValue('flPadrao', res.data.flPadrao ? String(QuestionRequired[0].key) : String(QuestionRequired[1].key));
                setFieldValue('flAtiva', res.data.flAtiva ? "0" : "1");
            }).catch((error) => {
                console.log('Erro ao consultar avaliação!', error);
            })
        }
        
    }, [])


    const {handleSubmit, handleChange, values, setFieldValue} = useFormik<ResearchQuestionInterface>({
        initialValues: initialValues,
        onSubmit: values => {
            if (values && values !== undefined) {

                values.flAtiva = values.flAtiva === '0' ? true : false;
                values.flPadrao = values.flPadrao === '0' ? true : false;

                values.idTipoOrigemPergunta.dsTipoPergunta = "";
                values.idTipoOrigemPergunta.flAtivo = true;

                if (values.valoresPesquisa === '1') {
                    values.idValoresPesquisa.vlrMinimo = 0;
                    values.idValoresPesquisa.vlrMaximo = 10;
                    values.idValoresPesquisa.dsValorPesquisa = RatingScore[1].value.toString();
                    values.idValoresPesquisa.vlrPesquisa = '10 estrelas'
                    values.flNPS = true;
                } 
            }
            
            handleSubmitForm({ ...values});
        }
    });

    return (
        <>
         
        <form onSubmit={handleSubmit}>
            <Details />
            {!request ?
            <GridComponent justify="flex-start" alignItems="flex-start" spacing={2} margin='20px 0px 0px 0px' >
                <FormLabel title="Titulo da Pergunta" sm={12} required={!disabled}>
                    <FormInput
                        name="dsPesquisa"
                        value={values.dsPesquisa}
                        onChange={handleChange}
                        disabled={false}
                        required

                    />
                </FormLabel>
                <FormLabel title="Valores possíveis" sm={12} md={7} required={!disabled}>
                    <FormSelect
                        displayEmpty={true}
                        name='valoresPesquisa'
                        value={String(values.valoresPesquisa ?? RatingScore[0].key)}
                        onChange={handleChange}
                        required
                    >
                        {RatingScore.map((information: RatingScoreInterface, index: number) => {
                            return <MenuItem value={String(information.key || index)} key={index}>{information.value}
                            </MenuItem>
                        })}
                    </FormSelect>
                </FormLabel>
                <FormLabel title="Obrigatório" sm={12} md={5}>
                    <FormSelect
                        displayEmpty={true}
                        name='flPadrao'
                        value={String(values.flPadrao ?? QuestionRequired[0].key)}
                        onChange={handleChange}
                    >
                        {QuestionRequired.map((information: QuestionRequiredInterface, index: number) => {
                            return <MenuItem value={String(information.key || index)} key={index}>{information.value}
                            </MenuItem>
                        })}
                    </FormSelect>
                </FormLabel>
                <FormLabel title="Status de Avaliação" required={!disabled} >
                    <FormRadio value={values.flAtiva || ''} name="flAtiva" onChange={handleChange} row  >
                        <FormControlRadio
                            label="Ativa"
                            value='0'
                            //disabled={disabled}
                            required
                            
                        />
                        <FormControlRadio
                            label="Inativa"
                            value="1"
                            //disabled={disabled}
                            required
                        />
                    </FormRadio>
                </FormLabel>
            </GridComponent> : <Progresse open={request} />}
            {request ? null : 
            <ButtonForm link={`/avaliacao-loja`} title={!disabled ? 'Adicionar avaliação' : 'Editar avaliação'} /> 
            }
        </form> 
        </>
    )
}